import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=22218a96&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22218a96')) {
      api.createRecord('22218a96', component.options)
    } else {
      api.reload('22218a96', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=22218a96&", function () {
      api.rerender('22218a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z2wjo4nUn78K/JS/comp/ImgFallback.vue"
export default component.exports